import React from "react";
import { Card, CardBody } from "reactstrap";
import { NavLink } from "react-router-dom";
import IntlMessages from "../../helpers/IntlMessages";
import defaultValues from "../../constants/defaultValues";

const RequestLeftSideSection = ({ request, match }) => {
  const reviewStars = num => {
    const stars = [];
    const starCount = parseInt(num, 10);
    for (let i = 0; i < starCount; i += 1) {
      stars.push(<div key={i} className="react-rater-star-full" />);
    }
    for (let i = 0; i < 5 - starCount; i += 1) {
      stars.push(<div key={i + starCount} className="react-rater-star" />);
    }
    return <div>{stars}</div>;
  };

  const linkToBooking = () => {
    if (!request.booking) return "#";
    return (`${match.url.replace('alacarte/', '')
      .replace(`requests/${match.params.id}`, `bookings/${request.booking.id}`)}`);
  }

  const classNameForBookingStatus = () => {
    if (!request.booking) return "";

    const { status } = request.booking;
    if (status === "hotel_guest") return "success";
    else if (status === "awaiting_approval") return "warning";
    else if (status === "invalid_booking") return "danger";
    else return "dark";
  }

  const classNameForRequestOrderStatus = () => {
    const { order_status } = request;
    if (order_status === "paid") return "success";
    else if (order_status === "canceled") return "danger";
    else return "warning";
  }

  // Burayı satırı hiçbir şekilde silme
  if (!request) return (<>Request Not Found</>);

  return (
    <>
      <Card className="mb-4 text-center">
        <CardBody>
          {request.is_staff && request.is_staff === "true" ? (
            <div className="badge badge-danger" style={{ fontSize: "15px" }}>
              <IntlMessages id="alacarte.request_owner_staff" />
            </div>
          ) : (
            <div>
              <h3 className="list-item-heading mb-2">{request.fullName}</h3>
              {request.phone_number ? (
                <div className="text-center">
                  <a href={`tel:${request.phone_number}`} style={{ paddingBottom: "2px", color: "green" }}>
                    <i className="simple-icon-phone" />
                    {request.phone_number}
                  </a>
                </div>
              ) : (
                ""
              )}
            </div>
          )}
          <NavLink to={() => linkToBooking}>
            {request.booking &&
              <div className={`badge badge-${classNameForBookingStatus()}`}
                style={{ fontSize: "15px", marginTop: "15px" }}
              >
                <IntlMessages id={defaultValues.bookingStatusEnum[request.booking.status]} />
              </div>
            }

            <div className="separator mb-4 mt-4" />

            {request.booking ?
              (
                <div className="d-table">
                  <div className="d-table-row">
                    <div className="text-muted float-left w-50 mb-1">
                      <IntlMessages id="bookingDetails.checkin" />
                    </div>
                    <div className="w-50 float-right mb-1">{`${request.checkin_date}`}</div>
                  </div>
                  <div className="d-table-row">
                    <div className="text-muted float-left w-50 mb-1">
                      <IntlMessages id="bookingDetails.checkout" />
                    </div>
                    <div className="w-50 float-right mb-1">{`${request.checkout_date}`}</div>
                  </div>
                  <div className="d-table-row">
                    {request.booking.rooms ?
                      (
                        <div>
                          <div className="text-muted float-left w-50 mb-1">
                            <IntlMessages id="bookingDetails.room" />
                          </div>
                          <div className="w-50 float-right mb-1">
                            {`${request.booking.rooms.join(" , ")}`}
                          </div>

                          {request.booking.butler && (
                            <>
                              <div className="text-muted float-left w-50 mb-1">Butler</div>
                              <div className="w-50 float-right mb-1">{`${request.booking.butler}`}</div>
                            </>
                          )}
                        </div>
                      ) : (
                        <div>
                          <div className="text-muted float-left w-50 mb-1">
                            <IntlMessages id="bookingDetails.room" />
                          </div>
                          <div className="w-50 float-right mb-1">
                            {`${request.room_number ? request.room_number : ""}`}
                          </div>
                        </div>
                      )
                    }
                  </div>
                </div>
              ) : request.room_number ? (
                <div>
                  <div className="text-muted float-left w-50 mb-1">
                    <IntlMessages id="bookingDetails.room" />
                  </div>
                  <div className="w-50 float-right mb-1">
                    {`${request.room_number ? request.room_number : ""}`}
                  </div>
                </div>
              ) : !request.booking && !request.is_staff ? (
                <div>
                  <IntlMessages id="request.no_booking_info" />
                </div>
              ) : (
                ""
              )
            }

            {request.service_type === "LOL_REQUEST" &&
              <div>
                <div className="text-muted float-left w-50 mb-1">
                  <IntlMessages id="alacarte.room_number" />
                </div>
                <div className="w-50 float-right mb-1">{`${request.room_number}`}</div>
              </div>
            }
          </NavLink>
        </CardBody>
      </Card>

      {request.payable && request.payable === "true" &&
        <Card className="mb-4 mt-4 ">
          <CardBody>
            <h3 className="list-item-heading mb-2 ">
              <i className="simple-icon-credit-card" />
              <IntlMessages id="request.payable_status" />
            </h3>

            <div className="separator mb-2 mt-1" />

            <div>
              <div className="text-muted float-left w-50 mb-2 mt-1">
                <IntlMessages id="request.payable_status" />
              </div>
              <div className="w-50 float-right mb-2 mt-1">
                <div className={`badge badge-${classNameForRequestOrderStatus()}`}>
                  <IntlMessages id={`${defaultValues.requestPayableStatusEnum[request.order_status]}`} />
                </div>
              </div>

              {request.order_status && request.order_status === "awaiting_payment" &&
                <div>
                  <div className="text-muted float-left w-50 mb-1">
                    <IntlMessages id="request.payable_payment" />
                  </div>
                  <div className="w-50 float-right mb-1">
                    {request.order &&
                      request.order.expired_control &&
                      request.order.expired_control === true ? (
                      <IntlMessages id="report.expired" />
                    ) : (
                      <IntlMessages id="report.not_expired" />
                    )}
                  </div>
                </div>
              }

              <div className="text-muted float-left w-50 mb-1">
                <IntlMessages id="request.payable_total_amount" />
              </div>
              <div className="w-50 float-right mb-1">{`${request.total_amount}`}</div>

              <div className="text-muted float-left w-50 mb-3">
                <IntlMessages id="request.payable_currency" />
              </div>
              <div className="w-50 float-right mb-3">{`${request.price_currency}`}</div>
            </div>

            <h3 className="list-item-heading mb-2 ">
              <i className="simple-icon-book-open" />
              <IntlMessages id="request.details" />
            </h3>

            <div className="separator mb-2 mt-1" />

            {request.order?.logs?.items?.length > 0 ?
              (
                <div>
                  {request.order.logs.items.map((res, index) => (
                    <Card key={index} className="mb-1 mt-1" style={{ fontSize: "12px" }}>
                      <CardBody>
                        <div className="text-muted mb-1 w-100">
                          <IntlMessages id="request.details" />:
                        </div>
                        {res.detail && <div className="mb-1 float-left w-100"> {res.detail}</div>}
                      </CardBody>
                    </Card>
                  ))}
                </div>
              ) : (
                <IntlMessages id="request.no_payable_details" />
              )
            }
          </CardBody>
        </Card>
      }

      <Card className="mb-4">
        <CardBody>
          <div className="w-100 float-left mb-1">
            <IntlMessages id="request.created_at" /> {request.created_at_date}
          </div>
          <div className="w-100 float-left mb-1">
            {" "}
            <IntlMessages id="request.last_update" /> {request.updated_at_date}
          </div>
          <div className="w-100 float-left mb-2">
            <IntlMessages id="request.due_date" /> {request.due_at_date}
          </div>
        </CardBody>
      </Card>

      {request.rating && (
        <Card className="mb-4">
          <CardBody>
            <div className="w-100 float-left mb-1">
              <IntlMessages id="request.survey_score" /> {`: ${parseInt(request.rating, 10)}/5`}
            </div>
            <div>{reviewStars(request.rating)}</div>
          </CardBody>
        </Card>
      )}
    </>
  );
};

export default RequestLeftSideSection;
